import { useState } from 'react'
import Swal from 'sweetalert2'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export const useExpenseDateRangeFilter = updateFilters => {
	const { t } = useTranslation()
	const [fromDate, setFromDate] = useState('')
	const [toDate, setToDate] = useState('')

	const handleDateRangeFilter = async () => {
		const formatDateForInput = date => {
			if (!date) return ''
			return moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : ''
		}

		const result = await Swal.fire({
			title: t('expenses.list.dateFilter.title'),
			html: `
				<div style="text-align:left;">
					<div style="margin-bottom:15px;">
						<label style="display:block; margin-bottom:5px; font-weight:bold;">${t('expenses.list.dateFilter.fromDate')}</label>
						<input type="date" id="expense-from-date" value="${formatDateForInput(fromDate)}" class="swal2-input" style="width:90%;" />
					</div>
					<div style="margin-bottom:15px;">
						<label style="display:block; margin-bottom:5px; font-weight:bold;">${t('expenses.list.dateFilter.toDate')}</label>
						<input type="date" id="expense-to-date" value="${formatDateForInput(toDate)}" class="swal2-input" style="width:90%;" />
					</div>
					<p style="font-size:12px; color:#6b7280;">${t('expenses.list.dateFilter.note')}</p>
				</div>
			`,
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonText: t('expenses.list.dateFilter.apply'),
			denyButtonText: t('expenses.list.dateFilter.clear'),
			cancelButtonText: t('expenses.list.dateFilter.cancel'),
			preConfirm: () => {
				const selectedFrom = document.getElementById('expense-from-date')?.value || ''
				const selectedTo = document.getElementById('expense-to-date')?.value || ''

				if (selectedFrom && selectedTo && selectedFrom > selectedTo) {
					Swal.showValidationMessage(t('expenses.list.dateFilter.invalidRange'))
					return false
				}

				return {
					fromDate: selectedFrom || '',
					toDate: selectedTo || '',
				}
			},
		})

		if (result.isDenied) {
			setFromDate('')
			setToDate('')
			updateFilters({ fromDate: null, toDate: null })
			return
		}

		if (result.isConfirmed) {
			const { fromDate: selectedFromDate, toDate: selectedToDate } = result.value
			setFromDate(selectedFromDate)
			setToDate(selectedToDate)

			const payload = {}
			if (selectedFromDate) payload.fromDate = selectedFromDate
			if (selectedToDate) payload.toDate = selectedToDate

			updateFilters(Object.keys(payload).length ? payload : { fromDate: null, toDate: null })
		}
	}

	const getDateRangeDisplay = () => {
		if (!fromDate && !toDate) return ''
		const format = date => (date ? moment(date).format('YYYY-MM-DD') : '')

		if (fromDate && toDate) return `${format(fromDate)} - ${format(toDate)}`
		if (fromDate) return t('expenses.list.dateFilter.from', { date: format(fromDate) })
		if (toDate) return t('expenses.list.dateFilter.until', { date: format(toDate) })
		return ''
	}

	return {
		fromDate,
		toDate,
		handleDateRangeFilter,
		getDateRangeDisplay,
	}
}
